export interface CitationIdMap {
  /** citation.n → 고유 DOM id */
  [n: number]: string;
}

let citeSeq = 0;

/** citations 배열로부터 n → DOM id 매핑 생성 */
export function buildCitationIdMap(citationNs: number[]): CitationIdMap {
  const map: CitationIdMap = {};
  for (const n of citationNs) {
    if (!(n in map)) {
      map[n] = `cite-${++citeSeq}`;
    }
  }
  return map;
}
